import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import '../../styles/hero.css';

export default function Hero() {
  return (
    <section id="home" className="hero">
      <video
        className="hero__video"
        autoPlay
        loop
        muted
        playsInline
        poster="https://images.unsplash.com/photo-1530267981375-f0de937f5f13?auto=format&fit=crop&w=1920&q=75"
        aria-hidden="true"
      >
        {/* Flat farmland at golden hour. Swap with your own farm video in src/assets/ */}
        <source
          src="https://cdn.pixabay.com/video/2023/08/10/175460-853585117_medium.mp4"
          type="video/mp4"
        />
      </video>
      <div className="hero__overlay" aria-hidden="true" />
      <div className="hero__vignette" aria-hidden="true" />

      <div className="container hero__content">
        <p className="hero__eyebrow">
          <FiMapPin />
          <span>
            Arumbavur, Perambalur District &nbsp;·&nbsp; under the foothills of
            Pachamalai
          </span>
        </p>

        <h1 className="hero__title">
          Rooted in Nature,
          <br />
          <em>Grown with Love</em>
        </h1>

        <p className="hero__subtitle">
          Naturally cultivated vegetables, fruits, grains and native seeds —
          nurtured in living soil, the traditional way, in harmony with the land
          and the seasons.
        </p>
      </div>

      {/* Animated wave divider */}
      <div className="hero__wave" aria-hidden="true">
        <svg
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,64 C240,120 480,20 720,54 C960,88 1200,120 1440,72 L1440,120 L0,120 Z"
            fill="var(--bg-light)"
          />
        </svg>
      </div>
    </section>
  );
}
